import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuth0Token } from './hooks/useAuth0Token';
import { useHistory } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';

const Auth0Routes: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect, handleRedirectCallback } = useAuth0();
  const { getToken, isLoading: tokenLoading } = useAuth0Token();
  const [loginTriggered, setLoginTriggered] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !loginTriggered) {
      setLoginTriggered(true);
      const returnTo = window.location.pathname + window.location.search;
      loginWithRedirect({
        authorizationParams: {
          screen_hint: 'login',
        },
        appState: { returnTo },
      });
    }
  }, [isLoading, isAuthenticated, loginTriggered, loginWithRedirect]);

  useEffect(() => {
    if (isAuthenticated) {
      const stored = sessionStorage.getItem('auth0_return_to');
      if (stored && stored !== '/' && stored !== '/dashboard') {
        sessionStorage.removeItem('auth0_return_to');
        history.replace(stored);
      }
    }
  }, [isAuthenticated, history]);

  if (isLoading || !isAuthenticated) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};

export default Auth0Routes;
